import { render, staticRenderFns } from "./AppInit.vue?vue&type=template&id=5b82d8b0&scoped=true&"
import script from "./AppInit.vue?vue&type=script&lang=js&"
export * from "./AppInit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b82d8b0",
  null
  
)

export default component.exports